<template>
    <div id="CourseText">
        <div class="col-md-12" :style="{height: contentHeight - 100 + 'px'}">
            <div class="chapters-text" v-html="content" ></div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    export default {
        name: "CourseText",
        components: {

        },
        props:{
           content: {},
            contentHeight: {}
        },
        data() {
            return {
            };
        },
       watch:{

       }
    };
</script>
<style lang="less">
    #CourseText {
    }
</style>
